import InjectError from "./error-handing";
//console.log(tsParticles);
var $ = require( "jquery" );
import Swiper from 'swiper';
import {Autoplay, Navigation, Pagination, EffectCards, EffectFade} from 'swiper/modules';
Swiper.use([Autoplay, Navigation, Pagination,EffectCards, EffectFade]);

// import Swiper styles
import 'swiper/css/bundle';

//IBG  // Also include in SCSS
import ibg from './libs/ibg.js'
$(document).ready(function(){
	ibg();
})

//MODAL  // Also include in SCSS
import './libs/modal.js';
import {CloseModal, OpenModal} from './libs/modal.js';
import {CreatePreview} from './image-preview.js';
const imagePreview = CreatePreview();
import InitContentReTyper from "./content-retyper";

//petite-vue reactive application
import './app/app.js';

$(document).on("click","[data-class-toggler]", function(){
	let group;
	if($(this).data("toggle-selector")){
		group = $($(this).data("toggle-selector"));
	}
	else if ($(this).data("toggle-parent-selector")) {
		group = $(this).closest("[data-class-toggle]");
	}
	else{
		group = $(this).closest("[data-class-toggle]");
	}
	group.toggleClass($(this).data("class-toggler"));
});
$(document).on("click","[data-click-selectable]", function(){
	let group = $(this).closest("[data-click-selectables]");
	let elems = group.find("[data-click-selectable]");
	let cssClass = group.data("click-selectables");
	for(let elem of elems){
		$(elem).removeClass(cssClass);
	}
	$(this).addClass(cssClass);
});
$(document).on("click","[data-previewable-image]", function(){
	let collectionContainer = $(this).closest("[data-previewable-collection]");
	if(collectionContainer.length === 0){
		imagePreview.OpenImage($(this).closest("img"));
	}
	else{
		let collection = collectionContainer.find("[data-previewable-image], [data-previewable-url]");
		console.log(collection);
		let imageCollectionIndex = collection.index($(this));
		console.log(imageCollectionIndex);
		let imageCollectionURL = [];
		for(let collectionElement of collection){
			if($(collectionElement).attr("data-previewable-url")){
				imageCollectionURL.push($(collectionElement).attr("data-previewable-url"));
			}
			else if($(collectionElement).is("img")){
				imageCollectionURL.push($(collectionElement).attr("src"));
			}
		}
		console.log(imageCollectionURL);
		imagePreview.OpenURLCollection(imageCollectionURL, imageCollectionIndex);
	}
});
$(document).ready(function (){
	InitWithCustomConfigs("[data-slider-config]","slider-config", (elem, config)=>new Swiper(elem[0], config));
	InitWithCustomConfigs("[data-content-retyper]","content-retyper", InitContentReTyper);
	InitProductSlider();

});
function InitProductSlider() {
	const slider = $(".product-preview-slider");
	if(slider.length === 0){
		return;
	}
	const elems = slider.find("img");
	new Swiper(slider[0],{
		effect: "fade",
		pagination: {
			el: '.product-preview-slider-pagination',
			renderBullet: function (index, className) {
				return `<img class="w-12 aspect-square rounded-sm overflow-hidden [:not(.active)]:opacity-50 cursor-pointer ${className}" src="${$(elems[index]).attr("src")}" alt="product preview" />`;
			},
			clickable: true,
			bulletActiveClass: "active",
			bulletClass: "bullet",
		},
	})
}

function InitWithCustomConfigs(selector, configSource, Init){
	const elems = $(selector);
	for(let elem of elems){
		elem = $(elem);
		const config = elem.data(configSource);
		if(typeof config !== "object"){
			console.error("Config is not an object \n" + config);
			// console.error("Slider config: ", config);
			InjectError(elem, "Config is not an object \n" + config);
			continue;
		}
		Init(elem,config);
	}
}



// generic dropdown
$(document).on( "click", "[data-dropdown-trigger]", function(){
	const container = $(this).closest('[data-dropdown-container]');
	const dropdowns = container.find('[data-dropdown]');
	const curWrapper = $(this).closest("[data-dropdown-wrapper]");
	const curDropdown = curWrapper.find("[data-dropdown]");
	const duration = container.data("dropdown-duration") || 400;
	if(!container.is('[data-dropdown-allow-multiple]')){
		for(let dropdown of dropdowns){
			if(dropdown !== curDropdown[0]){
				$(dropdown).closest('[data-dropdown-wrapper]').removeClass('active');
				$(dropdown).animate({
					height: "0px",
				}, duration);
			}
		}

	}
	if(curWrapper.hasClass('active')){
		curWrapper.removeClass('active');
		curDropdown.animate({
			height: 0 +"px",
		}, duration);
	}
	else{
		curWrapper.addClass('active');
		curDropdown.animate({
			height: curDropdown.children().css('height'),
		}, duration, ()=>curDropdown.css('height', 'auto'));

	}
})
import { tsParticles } from "./libs/tsparticles.engine.js";
import { loadAll } from "./libs/tsparticles.all.bundle.min.js";
function isMobileDevice() {
    var check = false;
    (function(a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4)))
            check = true;
    }
    )(navigator.userAgent || navigator.vendor || window.opera);
    return check;
};
let particleNumber = isMobileDevice() ? 40 : 120;
if (document.getElementById('snow-particles')) {
	(async () => {
	    await loadAll(tsParticles);
	    // await loadWobbleUpdater(tsParticles);
	    tsParticles.load({
	        id: "snow-particles",
	        options: {
	            smooth: true,
	            fpsLimit: 60,
	            fullScreen: {
	                enable: true,
	                zIndex: 200,
	            },
	            particles: {
	                color: {
	                    value: "#fff"

	                },
	                number: {
	                    value: particleNumber
	                },
	                shape: {
	                    type: "image",
	                    options: {
	                        image: {
	                            src: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' fill='%23fff' height='800px' width='800px' version='1.1' id='Capa_1' viewBox='0 0 298 298' xml:space='preserve'%3E%3Cg%3E%3Cpath d='M289.5,140.5h-24.606l11.031-11.03c2.93-2.929,2.93-7.678,0.001-10.606c-2.929-2.929-7.678-2.93-10.606-0.001 L243.681,140.5h-36.369l16.182-17.392c2.821-3.032,2.65-7.777-0.383-10.6c-1.243-1.156-2.775-1.802-4.345-1.961 c-0.952-0.047-21.495-0.003-21.495-0.003L221.315,86.5H251.5c4.143,0,7.5-3.357,7.5-7.5s-3.357-7.5-7.5-7.5h-15.186l17.69-17.69 c2.929-2.93,2.929-7.678,0-10.608c-2.93-2.928-7.844-2.928-10.774,0L225.167,61.1V45.5c0-4.143-3.357-7.5-7.5-7.5 c-4.143,0-7.5,3.357-7.5,7.5v30.601l-24.837,25.004l-0.415-22.645c-0.001-0.036,0.035-0.07,0.034-0.106 c-0.035-1.824-0.704-3.641-2.07-5.059c-2.873-2.982-7.778-3.07-10.761-0.194l-15.951,15.226V53.107l21.47-21.304 c2.929-2.93,3.012-7.678,0.083-10.607c-2.93-2.928-7.803-2.928-10.732,0l-10.821,10.696V7.5c0-4.143-3.357-7.5-7.5-7.5 c-4.143,0-7.5,3.357-7.5,7.5v24.393l-10.53-10.696c-2.93-2.928-7.594-2.928-10.524,0c-2.929,2.93-3.054,7.678-0.125,10.607 l21.179,21.304v35.421l-16.176-15.475c-3.009-2.847-7.67-2.718-10.52,0.289c-1.075,1.136-1.683,2.52-1.914,3.955 c-0.142,0.583-0.203,1.188-0.201,1.811l-0.088,21.229l-25.1-24.944V45.5c0-4.143-3.357-7.5-7.5-7.5s-7.5,3.357-7.5,7.5v14.894 L55.142,43.202c-2.93-2.928-7.594-2.928-10.524,0c-2.929,2.93-2.887,7.678,0.042,10.608L62.392,71.5H46.5 c-4.143,0-7.5,3.357-7.5,7.5s3.357,7.5,7.5,7.5h30.892l24.744,24.744l-23.057,0.831c-4.021,0.146-7.524,3.435-7.563,7.418 c-0.004,0.112-0.349,0.225-0.349,0.337c0,0.003,0,0.007,0,0.011c0,0.008,0.345,0.017,0.345,0.024 c0.045,1.875,0.955,3.736,2.395,5.158L89.748,140.5H55.025l-21.638-21.638c-2.93-2.928-7.678-2.928-10.607,0 c-2.929,2.93-2.929,7.678,0,10.607l11.03,11.03H8.5c-4.143,0-7.5,3.357-7.5,7.5s3.357,7.5,7.5,7.5h25.02L22.78,166.239 c-2.929,2.93-2.929,7.678,0,10.607c1.465,1.464,3.385,2.196,5.304,2.196c1.919,0,3.839-0.732,5.304-2.196L54.734,155.5h35.027 l-15.253,16.394c-2.821,3.032-2.65,7.777,0.383,10.6c1.444,1.344,3.277,2.009,5.106,2.009c0.034,0,0.068-0.005,0.103-0.005 c0.022,0,0.044,0.003,0.065,0.003c0.018,0,0.037,0,0.055,0l22.005-0.125L77.101,209.5H46.5c-4.143,0-7.5,3.357-7.5,7.5 s3.357,7.5,7.5,7.5h15.601l-17.399,17.399c-2.929,2.93-2.929,7.678,0,10.607c1.465,1.464,3.385,2.196,5.304,2.196 c1.919,0,3.672-0.732,5.137-2.196l17.025-17.191V250.5c0,4.143,3.357,7.5,7.5,7.5s7.5-3.357,7.5-7.5v-30.185l25.445-25.278 l0.977,24.39c0.148,4.046,3.517,7.306,7.532,7.225c1.364-0.027,2.844-0.465,4.312-1.543c1.063-0.781,15.734-15.812,15.734-15.812 v35.385l-20.971,21.137c-2.93,2.929-2.846,7.678,0.082,10.607c1.465,1.465,3.425,2.197,5.345,2.197 c1.919,0,3.693-0.732,5.157-2.196l10.387-10.532V290.5c0,4.143,3.357,7.5,7.5,7.5c4.143,0,7.5-3.357,7.5-7.5v-25.31l11.404,11.237 c1.465,1.464,3.468,2.196,5.387,2.196c1.919,0,3.881-0.732,5.345-2.196c2.929-2.93,2.783-7.678-0.146-10.607l-21.99-21.845v-35.7 c0,0,13.729,12.896,15.896,14.976c2.167,2.08,3.942,3.25,6.525,3.25c0.015,0,0.03,0,0.046,0c4.142,0,7.48-3.604,7.455-7.746 l-0.306-23.696l24.384,24.551V250.5c0,4.143,3.357,7.5,7.5,7.5c4.143,0,7.5-3.357,7.5-7.5v-15.891l18.064,17.897 c1.465,1.464,3.467,2.196,5.387,2.196c1.919,0,3.88-0.732,5.345-2.196c2.929-2.93,2.95-7.678,0.021-10.607L236.605,224.5H251.5 c4.143,0,7.5-3.357,7.5-7.5s-3.357-7.5-7.5-7.5h-29.894l-25.742-25.742l23.059-0.831c0.082-0.003,0.162-0.016,0.243-0.021 c0.03-0.002,0.06-0.005,0.09-0.008c3.977-0.319,7.037-3.709,6.892-7.736c-0.087-2.424-1.32-4.531-3.155-5.837L209.138,155.5h34.835 l21.345,21.346c1.465,1.465,3.384,2.197,5.304,2.197c1.919,0,3.839-0.732,5.303-2.196c2.93-2.929,2.93-7.678,0.001-10.606 l-10.74-10.74H289.5c4.143,0,7.5-3.357,7.5-7.5S293.643,140.5,289.5,140.5z M200.795,125.483L186.823,140.5h-19.507l15.002-15.002 L200.795,125.483z M170.21,95.784l0.356,20.002l-14.399,14.315V109.16L170.21,95.784z M127.263,95.865l13.904,13.323v20.205 l-13.925-14.008L127.263,95.865z M96.862,126.444l19.762-0.712l14.768,14.768h-20.299L96.862,126.444z M97.246,169.477 L110.25,155.5h20.851l-13.841,13.841L97.246,169.477z M127.863,201.599l-0.854-21.042l14.158-14.241v21.604L127.863,201.599z M170.819,201.264l-14.652-13.478v-22.179l14.442,14.359L170.819,201.264z M200.991,168.564l-19.614,0.706l-13.77-13.77h20.292 L200.991,168.564z'/%3E%3C/g%3E%3Cscript xmlns=''/%3E%3Cscript xmlns=''/%3E%3C/svg%3E",
	                            width: 100,
	                            height: 100,
	                            replaceColor: true
	                        }
	                    }
	                },
	                size: {
	                    value: {
	                        min: 4,
	                        max: 12
	                    }
	                },
	                opacity: {
	                    value: {
	                        min: 0.2,
	                        max: 0.7
	                    }
	                },
	                move: {
	                    enable: true,
	                    direction: "bottom",
	                    outMode: "out",
	                    speed: {
	                        min: 1,
	                        max: 2
	                    },

	                },
	                // shadow:{
	                // 	enable: true,
	                // 	blur: 1,
	                // 	color: "#183250"
	                // },
	                rotate: {
	                    value: {
	                        min: 0,
	                        max: 360
	                    },
	                    animation: {
	                        enable: true,
	                        speed: {
	                            min: 10,
	                            max: 15
	                        },
	                    },
	                    direction: "random",
	                },
	                wobble: {
	                    distance: 10,
	                    enable: true,
	                    speed: 10,
	                },
	            },
	            interactivity: {
	                events: {
	                    onHover: {
	                        enable: true,
	                        mode: "repulse"
	                    }
	                },
	                modes: {
	                    bubble: {
	                        distance: 300,
	                        duration: 2,
	                        opacity: 2,
	                    },
	                    repulse: {
	                        distance: 200,
	                        duration: 0.4,
	                        speed: 0.05,
	                    }
	                }
	            }
	        }
	    });
	}
	)();
}
